/**
 * The dialog and toast layer, as a global.
 *
 * Six pages call these from inline scripts in EJS and cannot import anything,
 * and the bundles that can import are spread across the site, so one script in
 * the header is what everything shares. It replaces the SweetAlert plugin that
 * used to sit in that slot.
 *
 * Two doors, on purpose:
 *
 *   window.ui   what this is. ui.confirm, ui.alert, ui.prompt, ui.toast, and
 *               ui.dialog underneath them for anything with its own shape.
 *               New code uses these.
 *
 *   window.Swal the option names the 87 existing calls already pass, mapped
 *               onto the same dialog. It exists so that dropping the plugin did
 *               not have to mean rewriting all of them on one afternoon. See
 *               ui/swal.js; it goes when the last call site has moved.
 */
const swal = require('./ui/swal');
const { openDialog } = require('./ui/dialog');
const { alert, confirm, prompt } = require('./ui/ask');
const { toast } = require('./ui/toast');

window.ui = { alert, confirm, prompt, toast, dialog: openDialog };
window.Swal = swal;

/**
 * The two behaviours that used to be `onclick` and `onchange` attributes.
 *
 * They were the last inline handlers in the templates, and an inline handler is
 * inline script: as long as four of them existed, `script-src` had to carry
 * 'unsafe-inline', and that one keyword undoes most of what a Content-Security
 * -Policy is for. Both are one line of behaviour attached to markup, so they
 * become attributes that name the behaviour and one delegated listener each.
 *
 * Delegated from the document rather than bound per element, so that markup
 * rendered after this runs works too, and so this costs two listeners on a page
 * regardless of how many controls use it.
 */
document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-toggle]');
    if (!trigger) return;
    const target = document.getElementById(trigger.getAttribute('data-toggle'));
    if (target) target.classList.toggle('hidden');
});

document.addEventListener('change', (event) => {
    const control = event.target.closest('[data-submit-on-change]');
    if (control && control.form) control.form.submit();
});
